import { Box, Skeleton, SkeletonText, Stack } from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';

export const EventListPlaceholder: React.FC<{
  length?: number;
}> = ({ length = 5 }) => {
  return (
    <Stack spacing="4">
      {[...Array(length)].map((_, index) => (
        <Card key={index}>
          <Box p="4">
            <Skeleton height="168px" />
            <SkeletonText mt="4" noOfLines={3} />
          </Box>
        </Card>
      ))}
    </Stack>
  );
};
